import React from "react";

import SignupForm from "./Components/FormControl/SignupForm";

import AuthLayout from "@/Components/Layouts/Native/AuthLayout";

function SignupScreen(): React.JSX.Element {
  return (
    <AuthLayout>
      <SignupForm />
    </AuthLayout>
  );
}

export default SignupScreen;
